function initCartStore() {
    console.log('Alpine cart store init');
    Alpine.store('cart', {
      items: [],
      itemsCount: 0,
      totalPrice: '0.00',
      isCartOpen: false,
      isLoading: false,
      debounceUpdate: null,
      errorMessage: '',
      shippingDiscount: { 
        shippingProgress: 0,
        shippingPrice: 35,
        shippingLeft: 35,
        isFreeShippingUnlocked: false,
      },

      options: {
        showSellingPlan: true, 
      },
  
      async loadCart() {
        this.isLoading = true;
        this.errorMessage = '';
  
        try {
          const resp = await fetch('/cart.js');
          const data = await resp.json();
          this.items = data.items;
          this.updateItemsCount();
          this.updateTotalPrice(); 
          console.log('Test this.items', this.items);
          console.log('Test this.totalPrice', this.totalPrice);
        } catch (err) {
          this.errorMessage = 'Failed to load the cart. Please try again.';
        } finally { 
          this.initRecommendationsCarousel();
          this.isLoading = false;
        }
      },
    
      async addMultiplyToCart(productsArr) {
        this.isLoading = true;
        this.errorMessage = '';
  
        const formData = { items: productsArr };
  
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          });
  
          await this.loadCart();

          // ─── Fire ATC event BEFORE refreshSections ────────────────
          const paidProducts = productsArr.filter(p =>
            !p.properties || p.properties['_offer'] === undefined
          );

          paidProducts.forEach(product => {
            const cartItem = this.items.find(item =>
              item.variant_id === product.id
            );
            if (cartItem && window.Shopify?.analytics?.publish) {
              window.Shopify.analytics.publish('custom_add_to_cart', {
                variantId: String(product.id),
                productTitle: cartItem.product_title,
                price: (cartItem.price / 100).toFixed(2),
                currency: window.Shopify?.currency?.active || 'USD',
                quantity: product.quantity || 1
              });
              console.log('[alpine-cart] ATC published for:', cartItem.product_title);
            }
          });
          // ──────────────────────────────────────────────────────────

          await this.refreshSections();
          window.location.href = '/checkout';
        } catch (err) {
          this.errorMessage = 'Failed to add the product. Please try again.';
        } finally {
          this.isLoading = false;
        }
      },
  
      async updateCart(itemKey, quantity) {
        this.isLoading = true;
        this.errorMessage = '';
        console.log('updateCart ', itemKey);
  
        try {
          const resp = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(itemKey), quantity })
          });
  
          if (!resp.ok) {
            throw new Error('Failed to update the cart.');
          }
  
          const data = await resp.json();
          this.items = data.items;
          this.updateItemsCount();
          this.updateTotalPrice();

          await this.refreshSections();
        } catch (err) {
          this.errorMessage = err.message;
        } finally {
          this.isLoading = false;
        }
    },
  
    async clearCart() {
      this.isLoading = true;
      this.errorMessage = '';
      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        this.items = [];
        this.itemsCount = 0;
        this.updateTotalPrice();

        await this.refreshSections();
      } catch (err) {
        this.errorMessage = 'Failed to clear the cart. Please try again.';
      } finally {
        this.isLoading = false;
      }
    },
   
    async removeFromCart(itemKey) {
      await this.updateCart(itemKey, 0);
    },

    async refreshCart() {
      console.log('Refreshing cart...'); 

      await this.loadCart();
      await this.refreshSections();

      this.toggleCart();
    },
  
    toggleCart(status = null) {
      if (status === null) {
          this.isCartOpen = !this.isCartOpen;
      } else {
          this.isCartOpen = Boolean(status);
      }
    },
  
    updateItemsCount() {
      this.itemsCount = this.items.reduce((total, item) => total + item.quantity, 0);
    },

    showQuantity(itemId) {
      const item = this.items.find((item) => item.id === itemId);
      return item ? item.quantity : 0;
    },

    updateTotalPrice() {
      // Free gift lines (CNV-6636) are made $0 by a discount at checkout, so they don't count here.
      const paidItems = this.items.filter((item) => !(item.properties && item.properties._free_gift));
      const total = paidItems.reduce((sum, item) => sum + (item.price * item.quantity) / 100, 0);
      this.totalPrice = Number(total.toFixed(2));
      console.log('Updated totalPrice:', this.totalPrice);
      this.shippingDiscount = {
        isFreeShippingUnlocked: total >= this.shippingDiscount.shippingPrice,
        shippingLeft: +(this.shippingDiscount.shippingPrice - total).toFixed(2),
        shippingProgress: Math.min(100, (total / this.shippingDiscount.shippingPrice) * 100),
        shippingPrice: this.shippingDiscount.shippingPrice
      };
    },

    async addToCart({
        variantId, 
        quantity = 1,
        properties = {},
        sellingPlanId = null
      }, showCart = true) {
        if (!variantId) {
          console.error('Variant ID is required to add a product to the cart.');
          return Promise.reject('No variantId'); 
        }

        this.isLoading = true;
        this.errorMessage = '';
  
        let requestData = {
          items: [{
            id: variantId,
            quantity: quantity,
            properties,
          }]
        };
        
        if (sellingPlanId) {
          requestData.items[0].selling_plan = sellingPlanId;
        }
  
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData),
          });
  
          await this.loadCart();

          if (!properties['_offer']) {
            const cartItem = this.items.find(item => item.variant_id === Number(variantId));
            if (cartItem && window.Shopify?.analytics?.publish) {
              window.Shopify.analytics.publish('custom_add_to_cart', {
                variantId: String(variantId),
                productTitle: cartItem.product_title,
                price: (cartItem.price / 100).toFixed(2),
                currency: window.Shopify?.currency?.active || 'USD',
                quantity: quantity
              });
            }
          }

          await this.refreshSections();
  
          if (showCart) {
            this.toggleCart();
          }
        } catch (err) {
          this.errorMessage = 'Failed to add the product. Please try again.';
        } finally {
          this.isLoading = false;
        }
      },

      async refreshSections(sections = ['alp-1-items', 'alp-3-footer', 'alp-5-free-return', 'alp-2-recommendations']) {
        try {
          const resp = await fetch(`/cart?sections=${sections.join(',')}`);
          const data = await resp.json();
   
          sections.forEach(id => {
            if (data[id] && document.querySelector(`#${id}`)) {
              document.querySelector(`#${id}`).outerHTML = data[id];
            }
          });
        } catch (err) {
          console.error('Failed to refresh cart sections', err);
        } finally {
          setTimeout(() => this.initRecommendationsCarousel(), 50);
        }
      },

      updateCartDebounced({ line, quantity }) {
        clearTimeout(this.debounceUpdate); 
        this.debounceUpdate = setTimeout(() => {
          this.changeQty({ line, quantity });
        }, 400); 
      },

      initRecommendationsCarousel() {
        const swiperEl = document.querySelector('#swiper-cart-recommendations');
        if (!swiperEl || typeof Swiper === 'undefined') {
          console.log('No recommendations carousel found, skipping init.');
          return;
        }
    
        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
      
        new Swiper(swiperEl, {
          slidesPerView: 3.5,
          spaceBetween: 16,
          navigation: {
            nextEl: '#swiper-cart-recommendations .swiper-button-next',
            prevEl: '#swiper-cart-recommendations .swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 3.9,
              spaceBetween: 20,
            },
          },
        }); 
      
        console.log('Recommendations carousel initialized.');
      },
  
      async changeQty({ line, quantity }) {
        console.log('changeQty', line, quantity);  
        this.isLoading = true;  
        
        if (quantity < 1) {
          await this.remove({ line });
          return;
        };
          
        const resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        const data = await resp.json();
        this.items = data.items;
        this.updateItemsCount();  
        this.updateTotalPrice();  

        await this.refreshSections();
        this.isLoading = false;
      },
  
      async changeSellingPlan({ line, qty, planId }) {
        this.isLoading = true;
        const resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: qty, selling_plan: planId })
        });
        const data = await resp.json();
        this.items = data.items;
        this.updateItemsCount();  
        this.updateTotalPrice(); 

        await this.refreshSections();
        this.isLoading = false;
      },
  
      async remove({ line }) {
        this.isLoading = true;
        const resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: 0 })
        });
        const data = await resp.json();
        this.items = data.items;
        this.updateItemsCount();  
        this.updateTotalPrice(); 

        await this.refreshSections();
        this.isLoading = false;
      }
    });
  
    Alpine.store('cart').loadCart();
}

if (window.Alpine) {
  initCartStore();
} else {
  document.addEventListener('alpine:init', initCartStore);
}

// Product forms also submit through the theme's product island (island-product.bundle.js), which
// adds to cart on its own. Handle the submit here first (capture phase) and stop it there, so one
// click adds once and opens this drawer.
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (form.matches("form[action='/cart/add']")) {
    e.preventDefault();
    e.stopPropagation();
    const fd = new FormData(form);
    const variantId = fd.get('id');
    const quantity  = fd.get('quantity') || 1;
    const sellingPlanId = fd.get('selling_plan') || null;

    await Alpine.store('cart').addToCart({ variantId, quantity, sellingPlanId }, true);
  }
}, true);